module.exports = __webpack_public_path__ + "static/media/nri.a3d7b7f9.gif";